module.exports = __webpack_public_path__ + "static/img/hook.98b384f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static_dazzle/images/bgs/hook.png
// module id = I02X
// module chunks = 1